import React, { useCallback } from 'react'
import { useForm } from "react-hook-form";

import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'

import { logoutBankUser } from '../../config/redux/slice/bankUserSlice'
import { onSearch } from '../../config/redux/slice/appSlice'
import { appUrls } from '../../utils/urls/appUrls'
import { handleSidebarClick } from '../../helpers/sideBarToggle';
import { logoutUser } from '../../config/redux/slice/authSlice';
import { logoutAppUser } from '../../config/redux/slice/appSlice';
import { logoutNotapUser } from '../../config/redux/slice/notapUserSlice';
import { logoutTransfereeUser } from '../../config/redux/slice/transfereeUserSlice';
import { ROLES } from '../../constants/index';

import default_img from '../../assets/images/default-img.jpeg'
import { formatUserRole } from '../../utils/lib';

export default function HeaderLayout() {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { register, handleSubmit} = useForm({ mode: 'onTouched' });
    const { userData } = useSelector((state) => state.authData)

    const getSearchResult = useCallback((data) =>{
      dispatch(onSearch({ searchValue: data.certificate_number }));

      const RESULT_MAP = {
        [ROLES.TRANSFEREE.TEXT]: appUrls.certificates_search,
        [ROLES.BANK.TEXT]: appUrls.bank_certificates_search
      };

      const nextRoute = RESULT_MAP[userData.user_role] || appUrls.notap_certificates_search;
      navigate(nextRoute);
    }, [dispatch, navigate, userData?.user_role]);

    const logout = useCallback(() => {
      dispatch(logoutUser())
      dispatch(logoutBankUser())
      dispatch(logoutAppUser())
      dispatch(logoutNotapUser())
      dispatch(logoutTransfereeUser())
    }, [dispatch]);

  return (
    <header className="main-header" id="header">
      <nav className="navbar navbar-expand-lg navbar-light" id="navbar">
        <button onClick={()=>{handleSidebarClick()}} id="sidebar-toggler" className="sidebar-toggle">
          <i className='mdi mdi-menu'></i>
          <span className="sr-only">Toggle navigation</span>
        </button>

        <div className="navbar-right ">
          <div className="search-form">
            <form onSubmit={handleSubmit(getSearchResult)}>
              <div className="input-group input-group-sm rounded-0" id="input-group-search">
                <input 
                    type="text" 
                    autoComplete="off" 
                    id="certificate_number" 
                    className="form-control rounded-0" 
                    placeholder="Search..."
                    {...register("certificate_number")}
                  />
                <div className="input-group-append">
                  <button style={{fontSize: '1.3rem'}} className="btn bg-transparent border-0" type="button">
                    <i className='mdi mdi-magnify'></i>
                  </button>
                </div>
              </div>
            </form>
          </div>

          <ul className="nav navbar-nav">    
            <li className="dropdown user-menu">
              <button className="dropdown-toggle nav-link" data-toggle="dropdown">
                  <img src={default_img} className="user-image rounded-circle" alt="User" />
                  <span className="d-none d-lg-inline-block text-capitalize">{userData.fullname}</span>
                  <span className="d-none d-lg-inline-block text-uppercase text-smoke">{formatUserRole(userData?.user_role)}</span>
              </button>

              <ul className="dropdown-menu dropdown-menu-right">
                <li>
                  <Link className="dropdown-link-item" to={appUrls.user_profile}>
                    <i className="mdi mdi-account-outline"></i>
                    <span className="nav-text">My Profile</span>
                  </Link>
                </li>
                
                <li className="dropdown-footer">
                  <button onClick={logout} className="dropdown-link-item"> 
                    <i className="mdi mdi-logout"></i> 
                    <span className="nav-text">Log out</span>
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}
